import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function LinkHealthDialog({ open, brokenLinks, onCancel, onPublishAnyway, publishing }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="bg-[#121824] border-white/10 text-white" data-testid="link-health-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-amber-400">
            <i className="fa-solid fa-triangle-exclamation mr-2" />Some links might be broken
          </DialogTitle>
          <DialogDescription>We couldn't confirm these links are working — fans may hit an error page.</DialogDescription>
        </DialogHeader>
        <ul className="space-y-1.5 max-h-48 overflow-y-auto">
          {brokenLinks.map((l) => (
            <li key={l.link_id} className="flex items-center gap-2 text-sm text-amber-300 bg-amber-500/10 rounded-lg px-3 py-2" data-testid={`broken-link-item-${l.link_id}`}>
              <i className="fa-solid fa-link-slash text-xs shrink-0" />
              <span className="font-medium capitalize shrink-0">{l.label}:</span>
              <span className="truncate opacity-70 font-mono-slug">{l.url || "(no URL set)"}</span>
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancel} className="border-white/15 hover:bg-white/10" data-testid="link-health-review-button">
            Review Links
          </Button>
          <Button onClick={onPublishAnyway} disabled={publishing} className="bg-amber-500 hover:bg-amber-600 text-black font-bold" data-testid="link-health-publish-anyway-button">
            {publishing ? "Publishing..." : "Publish Anyway"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
